export const RouterName = {
  auth: {
    login: "/auth/login",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  doc: {
    dashboard: "/doc/dashboard",
  },
  dashboard: "/dashboard",
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  admins_logs: {
    admins_logs: "/admins-logs",
  },
  booking: {
    doctors: "/doctors",
    roles: "/roles",
    rooms: "/rooms",
    services: "/services",
    servicePricelist: "/services/:serviceId/pricelist",
    clientCategories: "/client-categories",
    clients: "/clients",
    referrals: "/referrals",
    clientAccount: "/clients/:clientId/account",
    medicalHistory: "/clients/:clientId/medical-history",
    planCategories: "/plan-categories",
    treatmentPlans: "/treatment-plans",
    appointments: "/appointments",
    calendar: "/calendar",
    invoices: "/invoices",
    receipts: "/receipts",
    expensesTypes: "/expenses-types",
    expensesList: "/expenses-list",
    paymentVouchers: "/payment-vouchers",
    expensesAccounts: "/expenses-accounts",
    fixedIncome: "/fixed-income",
  },
};
